import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=eb52134c"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"
import style0 from "./Detail.vue?vue&type=style&index=0&id=eb52134c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports